export enum ApplicationEmailStatus {
	PENDING = 'PENDING',
	DELIVERED = 'DELIVERED',
	OPENED = 'OPENED',
	UNKNOWN = 'UNKNOWN',
}

export namespace ApplicationEmailStatus {
	export function toDisplayText(
		applicationEmailStatus: ApplicationEmailStatus
	): string {
		switch (applicationEmailStatus) {
			case ApplicationEmailStatus.PENDING:
				return 'Pending';
			case ApplicationEmailStatus.DELIVERED:
				return 'Delivered';
			case ApplicationEmailStatus.OPENED:
				return 'Opened';
			case ApplicationEmailStatus.UNKNOWN:
				return 'Unknown';
			default:
				return 'Unknown';
		}
	}
}
